package com.neurobs.ccabserver.transcriptreview.components.transcriptselection

import com.neurobs.ccabserver.transcriptreview.states.{CommandRouterContext, ErrorState, TranscriptSelectionState, UserState}
import com.neurobs.ccabserver.transcriptreview.components.transcriptselection.components.{AccountSelector, AccountSubjectFilterListBox, PrimaryFilterCheckbox, ReviewedStatusCheckbox, StudySelector, TestFilterListBox, TestTranscriptSelector}
import com.neurobs.js.ccab.ServerContext
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useEffect
import slinky.web.html._

import scala.concurrent.ExecutionContext.Implicits.global

@react
object TranscriptSelection {

	case class Props()

	val component = FunctionalComponent[Props] { _ =>

		val selectionState = TranscriptSelectionState.accessState()
		val userState = UserState.accessState()
		val router = CommandRouterContext.accessState()
		val server = ServerContext.accessState()
		implicit val errorState = ErrorState.accessState
		router.updateSelectionList = data => selectionState.updateReviewedTestTranscriptId(data, userState.username)

		useEffect(() => {
			selectionState.data.value.study match {
				case None =>
				case Some(study) =>
					server.getAccountSubjectTests(studyId = study.id, reviewed = selectionState.data.value.reviewedStatus)._2 map {
						case Left(error) => errorState.addError(error.description)
						case Right(data) => selectionState.setSubjectTestData(Some(data))
					}
			}
		}, Vector(selectionState.data.value.study, selectionState.data.value.reviewedStatus))

		val primary = if (selectionState.testFilterIsPrimary()) TestFilterListBox(primaryFilter = true) else AccountSubjectFilterListBox(primaryFilter = true)
		val secondary = if (selectionState.testFilterIsPrimary()) AccountSubjectFilterListBox(primaryFilter = false) else TestFilterListBox(primaryFilter = false)

		div(
			div(
				className := "ui middle aligned three column centered grid"
			)(
				div(
					className := "row",
				)(
					div(className := "column")(
						AccountSelector(),
						StudySelector()
					),
					div(className := "column")(
						ReviewedStatusCheckbox(), br(), br(),
						PrimaryFilterCheckbox()
					),
					div(className := "column")()
				)
			),
			div(
				className := "ui top aligned three column centered grid"
			)(
				div(
					className := "row",
				)(
					div(className := "column")(
						primary
					),
					div(className := "column")(
						secondary
					),
					div(className := "column")(
						TestTranscriptSelector()
					),
				)
			)
		)
	}
}
